// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".responsive-canvas{position:relative;overflow:hidden}.responsive-canvas img{width:100%;max-width:100%}.responsive-canvas svg{position:absolute;top:0;left:0}.responsive-canvas .handle{fill:none;pointer-events:all;stroke:transparent;stroke-width:2px;cursor:move}.responsive-canvas:hover .handle{stroke:#fff}#transform{background:#ababab;background-size:contain}", ""]);
// Exports
module.exports = exports;
